import { useNavigate } from 'react-router-dom'
import AppShell from '@/components/AppShell'
import { PageHeader } from '@/components/PageHeader'
import AuthenticatorList from '@/components/authenticator/AuthenticatorList'
import { appRoutes } from '@/constants'

const Authenticator = () => {
  const navigate = useNavigate()

  const handleStartLocking = (authenticatorId: string) => {
    navigate(
      appRoutes.questPlanner.replace(':authenticatorId', authenticatorId)
    )
  }

  const handleViewQuests = (authenticatorId: string) => {
    navigate(appRoutes.unlock.replace(':authenticatorId', authenticatorId))
  }

  return (
    <AppShell>
      <div className="bg-shire-light font-body text-shire-dark mb-16">
        <PageHeader
          title="Authenticator"
          description="Secure your two-factor authentication codes with quest-based challenges. Add codes manually or by scanning QR codes, then lock them behind real-world quests for enhanced security."
        />

        <div className="p-4 pb-16 sm:px-6 sm:py-8">
          <div className="container mx-auto max-w-5xl">
            <div className="border-shire-bark/30 from-shire-light/80 rounded-2xl border-2 border-dashed bg-gradient-to-br to-white/90 p-6 shadow-xl backdrop-blur-sm sm:p-10">
              <AuthenticatorList
                onStartLocking={handleStartLocking}
                onViewQuests={handleViewQuests}
              />
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  )
}

export default Authenticator
